import amplitude from 'amplitude-js'

import { getMobileOperatingSystem } from 'helpers/getMobileOperatingSystem'
import { getOperatingSystemVersion } from 'helpers/getOperatingSystemVersion'

import { IEventLogger, TCommonEventProperties } from 'models/events.model'

import { Events } from 'services/eventLogger.service'

import { EventLoggerInstanceName } from 'root-constants'

interface IAmplitude {
  getInstance: (amplitudeInstanceName?: string) => typeof amplitude
  init: (
    apiKey: string,
    userId: string | null,
    options?: Record<string, unknown>,
  ) => void
  setUserId: (userId: string) => void
  setUserProperties: (properties: Record<string, string>) => void
  logEvent: (event: string, eventProperty?: Record<string, unknown>) => void
}

export class Amplitude implements IEventLogger {
  public readonly name: EventLoggerInstanceName
  private readonly amplitude: IAmplitude
  private readonly allowedEvents?: Events[]
  private userProperties: Record<string, string> = {}

  constructor({
    instanceName,
    apiKey,
    userId,
    options,
    allowedEvents,
  }: {
    instanceName: EventLoggerInstanceName
    apiKey: string
    userId: string
    options?: Record<string, unknown>
    allowedEvents?: Events[]
  }) {
    this.name = instanceName
    this.amplitude = amplitude.getInstance(instanceName)
    this.allowedEvents = allowedEvents
    this.amplitude.init(apiKey, userId || null, options)
  }

  log(event: Events, eventProperty?: Record<string, unknown>): void {
    if (this.allowedEvents && !this.allowedEvents.includes(event)) {
      return
    }

    const mergedEventProperty: TCommonEventProperties = {
      operating_system_version: getOperatingSystemVersion(),
      ...eventProperty,
    }
    this.amplitude.logEvent(event, mergedEventProperty)
  }

  configure(): void {
    this.setUserProperties()
  }

  private setUserProperties(): void {
    const userProperties = {
      'Device Type': getMobileOperatingSystem(),
      'Operating System Version': getOperatingSystemVersion(),
    }
    this.userProperties = userProperties
    this.amplitude.setUserProperties(userProperties)
  }
}
